import { html } from '@polymer/polymer/polymer-element';
import { KatapultWidget } from './katapult-widget.js';
import { DateTime } from 'luxon';
import '../../paper-table/paper-table.js';
import '../../style-modules/paper-table-style.js';
import '../../katapult-auth/katapult-auth.js';
import '../../katapult-elements/katapult-button.js';

class ClientCodingDashboardWidget extends KatapultWidget {
  // Override widget title template
  static get widgetTitleTemplate() {
    return html`Client Equipping Dashboard`;
  }

  // Override properties
  static get properties() {
    return {
      pageData: {
        type: Object,
        value: { title: 'Client Equipping Dashboard', description: 'Optimize' }
      },
      daysOfWeek: {
        type: Array,
        value: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday']
      },
      tableData: {
        type: Array,
        value: function () {
          return [];
        },
        notify: true
      },
      userData: {
        type: Array,
        value: function () {
          return [];
        },
        notify: true
      },
      userSchedule: {
        type: Array,
        value: function () {
          return [];
        },
        notify: true
      },
      thisUserSchedule: {
        type: Array,
        value: function () {
          return [];
        },
        notify: true
      },
      currentlyArray: {
        type: Array,
        value: function () {
          return [];
        },
        notify: true
      },
      nameOfNewUser: {
        type: Object,
        value: { first: 'no', last: 'name' }
      },
      uidOfNewUser: {
        type: String,
        value: ''
      },
      dashboard_code_support: {
        type: Object,
        value: function () {
          return {};
        },
        notify: true
      },
      globalMilestoneCount: {
        type: String,
        value: ''
      },
      currentDay: {
        type: Date,
        value: DateTime.now()
      }
    };
  }

  // Override body template
  static get bodyTemplate() {
    return html`
      <style is="custom-style">
        /* Scrollbar */
        ::-webkit-scrollbar {
          width: 5px;
        }
        ::-webkit-scrollbar-track {
          margin: 10px 0 15px 0;
        }
        ::-webkit-scrollbar-thumb {
          background: #888;
        }
        ::-webkit-scrollbar-thumb:hover {
          background: #007299;
        }
        /* General Styling */
        #mainDiv {
          overflow-x: auto;
          max-width: 750px;
          display: flex;
          border-radius: 15px;
        }
        li {
          list-style-type: none;
          margin-bottom: 2px;
        }
        ul {
          padding: 0;
          margin: 0;
          width: 90%;
        }
        paper-table {
          flex: 1;
        }
        /* LED Lights */
        .base {
          background-color: #717271;
        }
        .ahead-lit {
          background-color: lime;
        }
        .okay-lit {
          background-color: yellow;
        }
        .behind-lit {
          background-color: red;
        }
        .led {
          border-radius: 5px;
          width: 10px;
          height: 10px;
          margin: 5px;
          zoom: 2;
          float: left;
        }
        .lightsDiv {
          border-radius: 15px;
          width: 120px;
          height: 40px;
          float: right;
          margin-top: 10px;
        }
        /* Active User Dialogue Styling */
        #currentDropdown {
          width: 350px;
          float: left;
        }
        .tableInput {
          margin: 2px;
          padding: 5px;
          border-radius: 15px;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
          height: 65px;
        }
        .taskDay {
          width: 90px;
        }
        .taskDay:hover {
          cursor: grab;
        }
        .addTaskButton {
          height: 25px;
          width: 25px;
        }
        .addTaskButton:hover {
          cursor: pointer;
        }
        .buttonTable {
          width: 110px;
          height: 40px;
        }
        .tableInDialog {
          padding: 20px;
          border-radius: 15px;
          background: lightgray;
        }
        .tableInDialog paper-row {
          background-color: white;
        }
        .highlight {
          background: var(--primary-color);
        }
        /* New User Dialogue Styling */
        .button {
          width: 100px;
        }
        .buttonDiv {
          display: flex;
          justify-content: space-between;
          padding: 10px;
        }
        .inputRow {
          display: flex;
          background: white;
        }
        /* Table card styling, including styles for completed and overdue days */
        .personCard {
          height: 720px;
          min-width: 300px;
          padding: 3px;
          margin: 0px;
        }
        .tableCard[red] {
          border: 4px dotted #ff8300;
          background-color: #ffd6cc;
        }
        .tableCard[green] {
          border: 4px dotted #ff8300;
          background-color: white;
        }
        .tableCard[red] .checkboxes {
          --paper-checkbox-unchecked-color: #ff8300;
          --paper-checkbox-unchecked-ink-color: #ff8300;
        }
        .tableCard {
          flex-direction: column;
          margin: 4px;
          padding: 2px;
          border-radius: 10px;
          height: 7em;
        }
        .days {
          background-color: #f0f0f0;
        }
        .completed {
          margin: auto;
        }
        .top {
          color: white;
          position: relative;
          background: var(--primary-color);
          box-shadow: none;
        }
        .top::before {
          content: '';
          position: absolute;
          top: 0;
          bottom: 0;
          border-radius: 15px;
          left: 85%;
          right: 0;
          width: 45px;
          z-index: 1;
        }
        .currentTask {
          font-weight: bold;
        }
        .currentTask p {
          display: inline;
        }
        .dayBox {
          align-self: flex-start;
          padding: 5px;
          margin: 5px 10px;
          max-height: 16px;
          color: #007299;
        }
        .firstCardDiv {
          margin: 0 auto;
          width: fit-content;
        }
        .taskList {
          overflow-y: auto;
          align-items: start;
          width: 250px;
          padding: 0px;
        }
        .checkboxes {
          display: inline;
          --paper-checkbox-vertical-align: top;
          margin-right: -5px; /* Overrides the default margin */
        }
        .dot {
          animation: letterAnimation 1s ease-in-out infinite;
          display: none;
        }
        @keyframes letterAnimation {
          0% {
            opacity: 0;
            transform: translateX(-10px);
          }
          50% {
            opacity: 1;
            transform: translateX(0);
          }
          100% {
            opacity: 0;
            transform: translateX(10px);
          }
        }
        .list {
          width: 100%;
        }
        /* Milestones styling */
        #milestonesBanner {
          max-width: 750px;
          display: flex;
          border-radius: 10px;
          padding: 5px;
          margin: 4px;
          background-color: #ff8300;
        }
        #milestonesBanner span {
          color: white;
          font-size: 22px;
          font-weight: bold;
          margin: 0 auto;
        }
        .weeklyUserMilestones {
          border-radius: 10px;
          padding: 5px;
          margin: 4px;
          background-color: #007299;
        }
        .weeklyUserMilestones span {
          color: white;
          font-size: 16px;
          margin: 0 auto;
        }
      </style>

      <!-- main table -->
      <paper-row id="milestonesBanner">
        <span>[[globalMilestoneCount]]</span>
      </paper-row>
      <div id="mainDiv">
        <template is="dom-repeat" items="{{tableData}}" as="person" index-as="personIndex">
          <paper-table class="personCard" rounded>
            <paper-row class="tableCard top">
              <paper-cell>
                <div>
                  <div class="firstCardDiv">
                    <div class="base led" on-click="changeStatus" id="[[person.0.1]]ahead"></div>
                    <div class="base led" on-click="changeStatus" id="[[person.0.1]]okay"></div>
                    <div class="base led" on-click="changeStatus" id="[[person.0.1]]behind"></div>
                    <template is="dom-if" if="[[person.1.current]]">
                      <katapult-button
                        size="20"
                        style="height:36px;"
                        iconOnly
                        color="white"
                        id="[[person.0]]"
                        icon="add"
                        on-click="toggleCoderStatus"
                      ></katapult-button>
                    </template>
                    <template is="dom-if" if="[[!person.1.current]]">
                      <katapult-button
                        size="20"
                        style="height:36px;"
                        iconOnly
                        color="white"
                        id="[[person.0]]"
                        icon="menu"
                        on-click="viewTasks"
                      ></katapult-button>
                    </template>
                  </div>
                  <div style="font-size: 24px;">[[person.0.0]] [[person.0.1]]</div>
                </div>
              </paper-cell>
            </paper-row>
            <paper-row class="weeklyUserMilestones">
              <span>[[person.2.completed]] / [[person.2.total]] Milestones Completed</span>
            </paper-row>
            <template is="dom-repeat" items="{{daysOfWeek}}" as="nameOfDay" index-as="dayIndex">
              <paper-row
                class="tableCard days"
                green$="[[green(nameOfDay, person.0.0, person.0.1)]]"
                red$="[[red(nameOfDay, person.0.0, person.0.1)]]"
              >
                <paper-cell class="dayBox">{{nameOfDay}}</paper-cell>
                <template is="dom-if" if="[[checkComplete(person, dayIndex)]]">
                  <paper-cell class="completed">
                    <katapult-icon size="60" color="#FF8300" color="var(--primary-color)" icon="done" iconOnly></katapult-icon>
                  </paper-cell>
                </template>
                <paper-cell class="taskList">
                  <div class="list">
                    <ul>
                      <template is="dom-repeat" items="[[getTasks(person, dayIndex)]]" as="task">
                        <template is="dom-if" if="[[checkTask(task)]]">
                          <template is="dom-if" if="{{!task.complete}}">
                            <template is="dom-if" if="[[checkCurrent(personIndex, task)]]">
                              <li class="currentTask">
                                <paper-checkbox
                                  class="checkboxes"
                                  checked="{{task.complete}}"
                                  on-click="check"
                                  disabled="[[!person.1.current]]"
                                >
                                  [[task.description]]
                                  <p class="dot">...</p>
                                </paper-checkbox>
                              </li>
                            </template>
                            <template is="dom-if" if="[[!checkCurrent(personIndex, task)]]">
                              <li>
                                <paper-checkbox
                                  class="checkboxes"
                                  checked="{{task.complete}}"
                                  on-click="check"
                                  disabled="[[!person.1.current]]"
                                >
                                  [[task.description]]
                                  <p class="dot">...</p>
                                </paper-checkbox>
                              </li>
                            </template>
                          </template>
                        </template>
                      </template>
                    </ul>
                  </div>
                </paper-cell>
              </paper-row>
            </template>
          </paper-table>
        </template>
      </div>

      <!-- Editing user's schedule dialog -->
      <katapult-dialog
        id="editCoder"
        color="#003E51"
        draggable="true"
        width="700"
        height="700"
        entry-animation="scale-up-animation"
        on-keypress="keyPressed"
        exit-animation="fade-out-animation"
        closeButton
        closeOnEscape
        closeOnOutsideClick
      >
        <div slot="title">Update Your Table</div>
        <div>
          <katapult-drop-down
            id="currentDropdown"
            label="Current Project"
            value-path=""
            items="[[currentlyArray]]"
            value="{{userData.1.project}}"
          ></katapult-drop-down>
        </div>

        <!-- Table for Tasks -->
        <template is="dom-repeat" items="{{userSchedule}}" as="date" index-as="index">
          <paper-table class="tableInDialog" id="[[index]]">
            <template is="dom-repeat" items="{{date.1}}" as="task" index-as="itemIndex">
              <paper-row class="tableInput" draggable="true" on-dragend="handleDrop" on-dragover="handleDrag" id="[[index]],[[itemIndex]]">
                <paper-cell>
                  <katapult-icon
                    color="var(--primary-color)"
                    on-click="addTaskToDay"
                    icon="add"
                    class="addTaskButton"
                    id="[[index]]"
                    iconOnly
                  ></katapult-icon>
                  <span class="taskDay">[[date.0]]</span>
                  <paper-input value="{{task.description}}" label="[[addOne(itemIndex)]]"></paper-input>
                  <paper-checkbox style="margin-left: 10px;" checked="{{task.complete}}"></paper-checkbox>
                  <katapult-icon
                    color="var(--primary-color)"
                    on-click="removeTaskToDay"
                    icon="delete"
                    class="addTaskButton"
                    id="[[index]],[[itemIndex]]"
                    iconOnly
                  ></katapult-icon>
                </paper-cell>
              </paper-row>
            </template>
          </paper-table>
        </template>
        <div class="buttonDiv">
          <katapult-button color="var(--secondary-color)" on-click="resetWeek" class="buttonTable">Reset Week</katapult-button>
          <katapult-button color="#003E51" on-click="returnToHomePage" class="buttonTable">Done</katapult-button>
        </div>
      </katapult-dialog>

      <!-- List of Each User's Tasks (to view completed and uncompleted) -->
      <katapult-dialog
        id="tasksCompleted"
        color="#003E51"
        draggable="true"
        width="700"
        height="700"
        entry-animation="scale-up-animation"
        on-keypress="keyPressed"
        exit-animation="fade-out-animation"
        closeButton
        closeOnEscape
        closeOnOutsideClick
      >
        <div slot="title">Task List</div>

        <!-- Table for Total Tasks -->
        <template is="dom-repeat" items="{{thisUserSchedule}}" as="date" index-as="index">
          <template is="dom-if" if="[[checkEmpty(date.1)]]">
            <paper-table class="tableInDialog" id="[[index]]">
              <paper-row class="tableInput">
                <paper-cell>
                  <span style="width: 90px;">[[date.0]]</span>
                </paper-cell>
              </paper-row>
              <template is="dom-repeat" items="{{date.1}}" as="task" index-as="itemIndex">
                <paper-row class="tableInput">
                  <paper-cell>
                    <paper-checkbox style="margin-left: 10px;" checked="{{task.complete}}" disabled></paper-checkbox>
                    <span>{{task.description}}</span>
                  </paper-cell>
                </paper-row>
              </template>
            </paper-table>
          </template>
        </template>
      </katapult-dialog>

      <!-- The new user dialog -->
      <katapult-dialog
        id="newUserDialog"
        color="#003E51"
        draggable="true"
        width="400"
        height="400"
        entry-animation="scale-up-animation"
        on-keypress="keyPressed"
        exit-animation="fade-out-animation"
        closeButton
        closeOnEscape
        closeOnOutsideClick
      >
        <div slot="title">New User In Dashboard</div>
        <div>
          <p>
            We found a new user with the uid [[uidOfNewUser]], and found [[nameOfNewUser.first]] [[nameOfNewUser.last]] to match this user
          </p>
        </div>
        <div>
          <p>If necessary manually enter their name...</p>
          <div class="inputRow">
            <paper-input value="{{nameOfNewUser.first}}" label="First Name"></paper-input>
            <paper-input value="{{nameOfNewUser.last}}" label="Last Name"></paper-input>
          </div>
        </div>
        <div>
          <p>Would you like to add this person to the table?</p>
        </div>
        <div slot="buttons" class="buttonDiv">
          <katapult-button color="#003E51" on-click="returnToHomePageNewUser" class="button">No</katapult-button>
          <katapult-button color="#003E51" on-click="makeNewUser" class="button">Yes</katapult-button>
        </div>
      </katapult-dialog>
    `;
  }
  //
  // START FUNCTION
  //
  ready() {
    super.ready();
    this.checkUsersForNew();
  }

  //
  // NEW USER FUNCTIONS
  //
  async checkUsersForNew() {
    const userInfo = await FirebaseWorker.ref(`/photoheight/company_space/katapult/users`)
      .once('value')
      .then((s) => s.val());

    const widgetList = await FirebaseWorker.ref(`/photoheight/home/widget_catalog/widget_library`)
      .once('value')
      .then((s) => s.val());

    this.dashboard_code_support = await FirebaseWorker.ref(`/photoheight/home/dashboard_code_support`)
      .once('value')
      .then((s) => s.val());

    // Check for new people
    let userList;
    widgetList.forEach((widget) => {
      if (widget.label == 'Client Equipping Dashboard') userList = widget.access;
    });
    userList = Object.keys(Object.values(Object.values(userList)[0])[0]); // All the uids

    userList.forEach((personUID) => {
      // New person found
      if (!Object.keys(this.dashboard_code_support).includes(personUID)) {
        this.uidOfNewUser = personUID;
        this.nameOfNewUser = userInfo[personUID]?.name ? userInfo[personUID].name : { first: 'no', last: 'name' };
        this.shadowRoot.querySelector('#newUserDialog').open();
      }
    });

    // Firebase database listener, user data
    let dataRef = FirebaseWorker.database().ref(`/photoheight/home/dashboard_code_support`);
    dataRef.on('value', (snapshot) => {
      this.configTableData(snapshot.val());
    });
  }

  makeNewUser() {
    // make an object to give to database
    let newUser = {
      dashboard_data: {
        project: 'null',
        status: 'okay',
        schedule: {
          Friday: [{ complete: false, description: '' }],
          Thursday: [{ complete: false, description: '' }],
          Wednesday: [{ complete: false, description: '' }],
          Tuesday: [{ complete: false, description: '' }],
          Monday: [{ complete: false, description: '' }]
        }
      }
    };

    newUser.name = this.nameOfNewUser;
    // get them into the database
    this.dashboard_code_support[this.uidOfNewUser] = newUser;
    FirebaseWorker.ref(`photoheight/home/dashboard_code_support`).update(this.dashboard_code_support);
    this.returnToHomePageNewUser();
  }

  //
  // SIMPLE RETURN FUNCTIONS
  //
  checkComplete(person, day) {
    //Update table booleans
    this.darkenCard();

    return person[1].schedule[day].checked;
  }

  checkEmpty(day) {
    return day[0].description != '';
  }

  addOne(x) {
    return x + 1;
  }

  checkTask(task) {
    return task.description !== '';
  }

  checkCurrent(personIndex, task) {
    return task.description + '' == this.tableData[personIndex][1].project + '';
  }

  getTasks(person, dayIndex) {
    const schedule = person[1].schedule[dayIndex];
    return schedule ? schedule[1] : [];
  }

  //
  // STYLING FUNCTIONS
  //
  //Update css classes to change led lights
  updateDashboard() {
    this.tableData.forEach((person) => {
      const statusArray = ['ahead', 'okay', 'behind'];
      statusArray.forEach((status) => {
        const element = this.shadowRoot.querySelector('#' + person[0][1] + status);
        status === person[1].status ? element.classList.add(status + '-lit') : element.classList.remove(status + '-lit');
      });
    });
  }

  red(day, first, last) {
    //Update table booleans
    this.darkenCard();

    //Retrieve matching data from array, and return
    let returnVal = false;
    this.tableData.forEach((person) => {
      if (person[0][0] === first && person[0][1] === last) {
        person[1].schedule.forEach((activeDay) => {
          if (activeDay[0] === day) {
            returnVal = activeDay.red;
          }
        });
      }
    });
    return returnVal;
  }

  green(day, first, last) {
    //Update table booleans
    this.darkenCard();

    //Retrieve matching data from array, and return
    let returnVal = false;
    this.tableData.forEach((person) => {
      if (person[0][0] === first && person[0][1] === last) {
        person[1].schedule.forEach((activeDay) => {
          if (activeDay[0] === day) {
            returnVal = activeDay.checked;
          }
        });
      }
    });
    return returnVal;
  }

  darkenCard() {
    // Initialize date properties to now
    this.currentDay = new Date(DateTime.now());

    // Go through table and update boolean values for checked and red cards
    this.tableData.forEach((person) => {
      this.daysOfWeek.forEach((day, dayIndex) => {
        // Check if weekend or if already past the day
        if (dayIndex + 1 < this.currentDay.getDay() || this.currentDay.getDay() === 0 || this.currentDay.getDay() === 6) {
          let incomplete = false;
          person[1].schedule[dayIndex][1].forEach((task) => {
            //Check for incomplete tasks on old days, that have a description (aren't empty values)
            if (task.complete === false && task.description != '') {
              person[1].schedule[dayIndex].checked = false;
              person[1].schedule[dayIndex].red = true;
              incomplete = true;
            }
          });
          if (incomplete === false) {
            person[1].schedule[dayIndex].checked = true;
            person[1].schedule[dayIndex].red = false;
          }
        }
      });
    });
  }

  //
  // ON CLICK FUNCTIONS
  //
  viewTasks(e) {
    // Goes through list to find user that matches the user sent with the button id
    this.tableData.forEach((user) => {
      let idString = '';
      let index = 0;
      user[0].forEach((word) => {
        if (index === 0) {
          idString += word + ',';
        } else {
          idString += word;
        }
        index++;
      });
      if (e.target.id === idString) this.thisUserSchedule = user[1].schedule;
    });
    this.shadowRoot.querySelector('#tasksCompleted').open();
  }

  changeStatus(e) {
    // makes sure you can't change others
    const lightId = e.target.id;
    const userName = this.userData[0][1];
    // changes only your light on base
    if (userName + 'ahead' == lightId) {
      this.userData[1].status = 'ahead';
      this.updateDashboard();
      this.updateDatabase(this.userData[1].uid);
    } else if (userName + 'okay' == lightId) {
      this.userData[1].status = 'okay';
      this.updateDashboard();
      this.updateDatabase(this.userData[1].uid);
    } else if (userName + 'behind' == lightId) {
      this.userData[1].status = 'behind';
      this.updateDashboard();
      this.updateDatabase(this.userData[1].uid);
    }
  }

  check() {
    // Swap schedule object into userData
    this.userData[1].schedule = this.userSchedule;
    // Swap userData into tableData
    for (var i in this.tableData) {
      if (this.tableData[i].current == true) this.set(this.tableData[i], this.userData);
    }
    this.updateDatabase(this.userData[1].uid);
  }

  resetWeek() {
    this.userData[1].schedule = [
      ['Monday', [{ complete: false, description: '' }]],
      ['Tuesday', [{ complete: false, description: '' }]],
      ['Wednesday', [{ complete: false, description: '' }]],
      ['Thursday', [{ complete: false, description: '' }]],
      ['Friday', [{ complete: false, description: '' }]]
    ];
    this.updateDatabase(this.userData[1].uid);
  }

  addTaskToDay(e) {
    const index = e.target.id;
    this.saveSchedule();
    this.userData[1].schedule[index][1].push({ description: '', complete: false });
    this.updateDatabase(this.userData[1].uid);
  }

  removeTaskToDay(e) {
    const [indexOfDay, indexOfTask] = e.target.id.split(',');
    this.saveSchedule();
    this.userData[1].schedule[indexOfDay][1].splice(indexOfTask, 1);

    // Add a blank task if removing the task emptied the day
    if (this.userData[1].schedule[indexOfDay][1].length == 0)
      this.userData[1].schedule[indexOfDay][1][0] = { complete: false, description: '' };

    this.updateDatabase(this.userData[1].uid);
  }

  configTableData(data) {
    // get each person's status, schedule, dashboard_data to a local variable
    let switchArray = [];
    Object.entries(data).forEach((coder) => {
      // get schedule right
      var sortedSchedule = [];
      Object.entries(coder[1].dashboard_data.schedule).forEach((day) => {
        if (day[0] == 'Monday') sortedSchedule[0] = ['Monday', day[1]];
        if (day[0] == 'Tuesday') sortedSchedule[1] = ['Tuesday', day[1]];
        if (day[0] == 'Wednesday') sortedSchedule[2] = ['Wednesday', day[1]];
        if (day[0] == 'Thursday') sortedSchedule[3] = ['Thursday', day[1]];
        if (day[0] == 'Friday') sortedSchedule[4] = ['Friday', day[1]];
      });

      // get current user and all other users
      var currentUser = false;
      coder[0] == this.user.uid ? (currentUser = true) : (currentUser = false);

      const coderObject = {
        uid: coder[0],
        project: coder[1].dashboard_data.project ?? '',
        schedule: sortedSchedule ?? '',
        status: coder[1].dashboard_data.status ?? 'no status',
        current: currentUser
      };

      // [ [name, last] , { dashboard data } ]
      switchArray.push([Object.values(coder[1].name), coderObject]);

      // setup current user obj for changes
      if (currentUser == true) {
        this.userData = [Object.values(coder[1].name), coderObject];
        this.userSchedule = this.userData[1].schedule;
        // setup dropdown var
        this.currentlyArray = [];
        sortedSchedule.forEach((day) => {
          // each task for the day
          day[1].forEach((task) => {
            if (task.description) this.currentlyArray.push(task.description);
          });
        });
      }
    });

    this.tableData = switchArray;

    //Milestones Counting and Data Storing
    var [milestonesCompleted, milestonesTotal, index] = [0, 0, 0];
    this.tableData.forEach((user) => {
      var [trueCount, totalCount] = [0, 0];
      user[1].schedule.forEach((day) => {
        day[1].forEach((task) => {
          if (task.complete === true) {
            trueCount++;
            totalCount++;
          } else if (task.description != '') {
            totalCount++;
          }
        });
      });
      this.tableData[index].push({ completed: trueCount, total: totalCount });
      milestonesTotal += totalCount;
      milestonesCompleted += trueCount;
      index++;
    });
    this.globalMilestoneCount = 'Weekly Team Milestone Progress: ' + milestonesCompleted + ' / ' + milestonesTotal;

    setTimeout(() => {
      this.updateDashboard(), 1000;
    });
  }

  toggleCoderStatus() {
    this.shadowRoot.querySelector('#editCoder').open();
    this.userIs();
  }

  //
  // EVENTS
  //
  keyPressed(e) {
    if (e.key == 'Enter') this.returnToHomePage();
  }

  handleDrag(event) {
    event.preventDefault();

    const dialogRect = this.shadowRoot.querySelector('#editCoder').getBoundingClientRect();
    const mouseX = event.clientX - dialogRect.left;
    const mouseY = event.clientY - dialogRect.top;
    const tables = Array.from(this.shadowRoot.querySelectorAll('.tableInDialog'));

    tables.forEach((table) => {
      const rect = table.getBoundingClientRect();
      if (mouseX >= rect.left && mouseX <= rect.right && mouseY >= rect.top && mouseY <= rect.bottom) {
        table.classList.add('highlight');
      } else {
        table.classList.remove('highlight');
      }
    });
  }

  handleDrop(event) {
    this.saveSchedule();
    event.preventDefault();
    const draggedRowId = event.target.id;
    let closestTable;

    const dialogRect = this.shadowRoot.querySelector('#editCoder').getBoundingClientRect();
    const mouseX = event.clientX - dialogRect.left;
    const mouseY = event.clientY - dialogRect.top;
    const tables = Array.from(this.shadowRoot.querySelectorAll('.tableInDialog'));

    tables.forEach((table) => {
      table.classList.remove('highlight');
      const rect = table.getBoundingClientRect();
      if (mouseX >= rect.left && mouseX <= rect.right && mouseY >= rect.top && mouseY <= rect.bottom) {
        closestTable = table;
      }
    });

    var indicator = draggedRowId.split(',');
    var oldDay = indicator[0];
    var indexOfTask = indicator[1];
    var taskToSwap = this.userData[1].schedule[oldDay][1][indexOfTask];
    var newDay = closestTable.id;

    // if its a new day
    if (oldDay !== newDay) {
      this.userData[1].schedule[oldDay][1].splice(indexOfTask, 1);
      this.userData[1].schedule[newDay][1].push(taskToSwap);

      // Add a blank task if removing the task emptied the day
      if (this.userData[1].schedule[oldDay][1].length == 0) {
        this.userData[1].schedule[oldDay][1][0] = { complete: false, description: '' };
      }

      this.updateDatabase(this.userData[1].uid);
    }
  }

  //
  // RETURN TO HOME FUNCTIONS
  //
  returnToHomePage() {
    this.shadowRoot.querySelector('#editCoder').close();
    // Swap schedule object into userData
    this.saveSchedule();
  }

  returnToHomePageNewUser() {
    this.shadowRoot.querySelector('#newUserDialog').close();
  }

  // This function saves the current state of the schedule
  saveSchedule() {
    this.userData[1].schedule = this.userSchedule;
    // Swap userData into tableData
    for (var i in this.tableData) {
      if (this.tableData[i][1].current == true) this.set(this.tableData[i], this.userData);
    }
    this.updateDatabase(this.userData[1].uid);
  }

  userIs(event) {
    event ? (this.userData[1].status = event.target.id) : null;
    const statusArray = ['ahead', 'okay', 'behind'];
    statusArray.forEach((status) => {
      const element = this.shadowRoot.querySelector('#' + status);
      status === this.userData[1].status ? element?.classList.add(status + '-lit') : element?.classList.remove(status + '-lit');
    });
  }

  //
  // DATABASE UPDATE
  //
  updateDatabase(uid) {
    // Clean up userData for database
    const objectToTrade = this.userData;
    this.userData = this.userData.map((obj, index) => {
      if (index === 1) {
        const { current, uid, ...rest } = obj;
        return rest;
      }
      return obj;
    });

    // Bring schedule back to an object
    var objSchedule = {};
    for (var i in this.userData[1].schedule) {
      const key = this.userData[1].schedule[i][0];
      const value = this.userData[1].schedule[i][1];
      objSchedule[key] = value;
    }
    this.userData[1].schedule = objSchedule;
    FirebaseWorker.ref(`photoheight/home/dashboard_code_support/${uid}/dashboard_data`).update(this.userData[1]);
    this.userData = objectToTrade;
  }
}

window.customElements.define('client-coding-dashboard-widget', ClientCodingDashboardWidget);
